import {
  createSlice,
} from "@reduxjs/toolkit";
import { Reducer } from "./Reducer";
import { IErrorAlertObject, IInitialState } from "./Types";


const initialState: IInitialState = {
  openErrorAlert:false,
  error: {} as IErrorAlertObject
};

export const Slice = createSlice({
  initialState,
  name: "error-alert",
  reducers: Reducer,
});
